import React from 'react';
import Layout from '../../../../components/Layout';
import { MainColumn } from '../../../../components/Layout/ThirdPaneLayout';
import PageBar from '../../../../components/PageBar/PageBar';
import NotificationPreferences from './NotificationPreferences';

const NotificationSettings = (): JSX.Element => {
  return (
    <Layout>
      <MainColumn px="mainContent" pb="mainContent" height="inherit">
        <PageBar title="Notification Settings" />
        <NotificationPreferences />
      </MainColumn>
    </Layout>
  );
};

export default NotificationSettings;
